<template>
  <gj-modal
      :visible.sync="modalVisible"
      size="1200_auto"
      :loading="modalLoading"
      v-on="$listeners"
  >
    <template #header>{{id === null ? '添加' : '编辑'}}供应商</template>
    <template #content>
      <el-form
          ref="form"
          :model="form"
          label-width="120px"
      >
        <gj-area-title>基本信息</gj-area-title>
        <el-row>
          <el-col :span="8">
            <el-form-item
                prop="code"
                label="供应商编码"
                :rules="[
                  $gjRequired('请输入供应商编码'),
                  customCheckCode()
                ]"
            >
              <gj-input
                  :disabled="id !== null"
                  v-model="form.code"
                  placeholder="请输入供应商编码"
                  width="250px"></gj-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
                prop="name"
                label="供应商名称"
                :rules="[
                  $gjRequired('请输入供应商名称'),
                  customCheckName()
                ]">
              <gj-input
                  v-model="form.name"
                  placeholder="请输入供应商名称"
                  width="250px"></gj-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态" required>
              <gj-select
                  v-model="form.status"
                  :clearable="false"
                  :options="option.disableLowerCaseOption"
                  width="100%"></gj-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
                prop="buyerId"
                label="采购员"
                :rules="[
                  $gjRequired('请选择采购员')
                ]">
              <gj-creator-select
                  v-model="form.buyerId"
                  :clearable="false"
                  active
                  placeholder="请选择采购员"
                  width="250px"></gj-creator-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="供应商联系人">
              <gj-input
                  v-model="form.contact"
                  placeholder="请输入供应商联系人"
                  width="250px"></gj-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系人电话">
              <gj-input
                  v-model="form.contactPhone"
                  placeholder="请输入联系人电话"
                  width="100%"></gj-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="供应商地址">
            <gj-input
                v-model="form.addr"
                placeholder="请输入供应商地址"
                width="100%"></gj-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="QQ">
              <gj-input
                  v-model="form.qq"
                  placeholder="请输入QQ"
                  width="250px"></gj-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="邮箱">
              <gj-input
                  v-model="form.email"
                  placeholder="请输入邮箱"
                  width="250px"></gj-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="传真">
              <gj-input
                  v-model="form.fax"
                  placeholder="请输入传真"
                  width="100%"></gj-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="公司网址">
            <gj-input
                v-model="form.website"
                placeholder="请输入公司网址"
                width="100%"></gj-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="备注">
            <gj-input
                v-model="form.memo"
                placeholder="请输入备注"
                width="100%"></gj-input>
          </el-form-item>
        </el-row>
        <gj-area-title>结算信息</gj-area-title>
        <el-row>
          <el-form-item
              prop="settlementWay"
              label="结算方式"
              :rules="[
                $gjRequired('请选择结算方式')
              ]"
          >
            <gj-select
                :clearable="false"
                v-model="form.settlementWay"
                :options="option.settlementType"
                placeholder="请选择结算方式"
                width="250px"></gj-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="备注">
            <gj-input
                v-model="form.settlementMemo"
                placeholder="请输入备注"
                width="100%"></gj-input>
          </el-form-item>
        </el-row>
        <gj-area-title>收款信息</gj-area-title>
        <el-row>
          <el-col :span="8">
            <el-form-item label="收款方">
              <gj-input
                  v-model="form.payee"
                  placeholder="请输入收款方"
                  width="250px"></gj-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="银行名称">
              <gj-input
                  v-model="form.bankName"
                  placeholder="请输入银行名称"
                  width="250px"></gj-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="银行账号">
              <gj-input
                  v-model="form.bankAccount"
                  placeholder="请输入银行账号"
                  width="100%"></gj-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </template>
    <template #footer>
      <gj-button @click="cancel">取消</gj-button>
      <gj-button type="primary" @click="confirm(0)" :loading="loading">确定</gj-button>
      <gj-button :loading="loading2" @click="confirm(1)" type="primary" v-if="$permission('supplier:addQuote') && !hideSureQuote">确定并报价</gj-button>
    </template>
  </gj-modal>
</template>

<script>
  import {formRuleMixin, modalMixIn, responseMixin, userGuideMixin} from "@/minxins";
  import {isMeaningful, isMeaningless} from "@/utils/common";
  import {disableLowerCaseOption, settlementType} from "@/utils/options";
  import {addSupplier, checkSupplierCode, checkSupplierName, editSupplier, getSupplierDetail} from "@/api/purchase";

  export default {
    name: "supplier-edit",
    mixins: [modalMixIn, formRuleMixin, responseMixin, userGuideMixin],
    props: {
      id: null,
      hideSureQuote: false//新手任务时隐藏报价按钮
    },
    created() {
      if (isMeaningful(this.id)) {
        this.modalLoading = true;
        getSupplierDetail(this.id)
          .then((data) => {
            for (let key in data) {
              this.form[key] = data[key];
            }
          }).complete(() => this.modalLoading = false)
      }
    },
    data() {
      return {
        modalLoading: false,
        loading: false,
        form: {
          code: null,
          name: null,
          status: 'enable',
          buyerId: null,
          contact: null,
          contactPhone: null,
          addr: null,
          qq: null,
          email: null,
          fax: null,
          website: null,
          memo: null,
          settlementWay: 'cash',
          settlementMemo: null,
          payee: null,
          bankName: null,
          bankAccount: null,
        },
        option: {
          disableLowerCaseOption: disableLowerCaseOption,
          settlementType: settlementType,
        },
        loading2: false
      }
    },
    methods: {
      confirm(state) {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.loading = state === 0;
            this.loading2 = state === 1;
            if (isMeaningless(this.id)) {
              addSupplier(this.form)
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    this.$emit('after', state === 1 ? res.data : null);
                    this.$emit('userGuide', state);
                  })
                }).complete(() => {
                  this.loading = false;
                  this.loading2 = false;
              })
            } else {
              editSupplier(this.form)
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    this.$emit('after', state === 1 ? res.data : null);
                  })
                }).complete(() => {
                  this.loading = false;
                  this.loading2 = false;
              })
            }
          }
        });
      },
      customCheckName(trigger = ['blur']) {
        return {
          validator: (rule, value, callback) => {
            checkSupplierName(value, isMeaningful(this.id) ? this.id : '')
              .then((data) => {
                if (!data) {
                  callback();
                } else {
                  callback(new Error('该供应商名称已存在'));
                }
              })
          },
          trigger,
        }
      },
      customCheckCode(trigger = ['blur']) {
        return {
          validator: (rule, value, callback) => {
            checkSupplierCode(value, isMeaningful(this.id) ? this.id : '')
              .then((data) => {
                if (!data) {
                  callback();
                } else {
                  callback(new Error('该供应商编码已存在'));
                }
              })
          },
          trigger,
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-dialog__body{
    // padding-right: 30px;
  }
</style>
